import styled from "styled-components";
import { Button as AntButton, Form as AntForm, Input as AntInput } from "antd";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	padding: 20px 16px;

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: center;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #9f9fa2;
		font-size: 14px;
		font-weight: 200;
		line-height: 17.5px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const ChangePinTitle = styled.p`
	font-weight: 200;
	font-size: 14px;
	line-height: 17.5px; 
	color: #FFFFFF;
`;

export const SubTitle = styled.p`
	font-size: 14px;
	font-weight: 500;
	line-height: 17.5px; 
	color: #FFB829;
`;

export const Button = styled(AntButton)`
	margin-top: 20px;
	width: 100% !important;
	height: 52px !important;
	border-radius: 12px !important;
	box-sizing: border-box !important ;
	color: #f7f7f7;
	font-family: Plus Jakarta Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	:hover {
		background-color: #6d1304 !important;
	}
`;

export const Input = styled(AntInput.Password)`
	border-radius: 8px;
	border: 1.5px solid #212224;
	height: 52px;
	background-color: #050508;

	input {
		font-size: 16px !important ;
		text-align: left !important;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		color: white;
	}

	.ant-input {
		font-size: 17px !important;
		background-color: #050508;
	}

	.ant-input::placeholder {
		color: #686b6e;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
	}

	&&& {
		padding-left: 24px;
	}
`;

export const TitleWrapper = styled.div`
	background-color: #161719;
	height: 76px;
	margin-bottom: 24px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: 3px 0;
`;
